import { Box, Typography } from '@mui/material'
import React, { useState } from 'react'
import IconTooltipButton from '../../../../button/IconTooltipButton'
import { useSelector } from 'react-redux'
import DataGrid from '../../../../table/DataGrid'
import DialogWorkedExamples from './DialogWorkedExamples'
import { WEInfo } from '../../../../card/WorkedExampleInfo'

const FormWorkedExamples = ({ onChangeAlert, isLoading }) => {
  const [modal, setModal] = useState(null)
  const formData = useSelector((state) => state?.dr?.form?.workedExamples || [])

  const onSave = (data, type) => {
    if (type === 'create') {
      const newQuestion = {
        _id: data._id || new Date().getTime(),
        id: data._id || new Date().getTime(),
        comment: data.comment,
        media: data.media || []
      }
      onChangeAlert('workedExamples', [...formData, newQuestion])
    } else if (type === 'edit') {
      const newFormData = formData
        .map((item) => ({ ...item, _id: item._id || item.id }))
        .map((item) => {
        if (String(item._id) === String(data.id)) {
          return {
            ...item,
            comment: data.comment,
            media: data.media || []
          }
        }
        return item
      })
      onChangeAlert('workedExamples', newFormData)
    } else if (type === 'delete') {
      const newFormData = formData.map((item) => ({ ...item, _id: item._id || item.id }))
        .filter((item) => String(item._id) !== String(data.id))
      onChangeAlert('workedExamples', newFormData)
    }
  }

  return (
    <>
      <Box className='px-4 py-2 h-6 bg-primary text-primary-foreground flex items-center justify-between'>
        <Typography variant='inherit' className='font-bold capitalize' component='p'>
          Worked Examples
        </Typography>
        <div>
          <IconTooltipButton
            title='Add worked examples'
            icon='plus'
            classNameIcon='text-lg'
            style={{
              borderRadius: '0.5rem',
              padding: '0.45rem',
              color: 'var(--primary)',
              backgroundColor: '#fff',
              width: 25,
              height: 25
            }}
            className="shadow-sm"
            onClick={() => setModal({ type: 'create', form: {} })}
          />
        </div>
      </Box>
      <Box className='absolute top-36 bottom-0 inset-x-4'>
        <DataGrid
          id='add-remove-growth-goals'
          showSetting={false}
          loading={isLoading}
          rows={formData?.map((row, index) => {
            return {
              ...row,
              index: index + 1,
              workedExample: <WEInfo row={{...row, index}}/>,
              actions: 
              <div className='flex items-center gap-1 items-center justify-center'>
                <IconTooltipButton
                  id={`edit-${row._id}`}
                  disabled={isLoading}
                  title='Edit'
                  icon='pen'
                  onClick={() => setModal({ type: 'edit', form: { ...row, id: row._id || row.id } })}
                />
                <IconTooltipButton
                  id={`delete-${row._id}`}
                  disabled={isLoading}
                  title='Delete'
                  icon='trash-alt'
                  onClick={() => setModal({ type: 'delete', form: { ...row, id: row._id || row.id } })}
                />
              </div>
            }
          })}
          rowsPerPage={formData?.length || 0}
          columns={[
            { label: '#', key: 'index', align: 'center', width: 20, show: true, hide: false },
            { label: 'Worked example', key: 'workedExample', show: true, hide: false },
            { label: 'Actions', key: 'actions', align: 'center', width: 50, show: true, hide: false }
          ]}
          labelNoRows="You don't have any worked examples yet"
        />
      </Box>
      { modal &&
        <DialogWorkedExamples
          open={modal}
          onClose={() => setModal(null)}
          formData={modal.form}
          onSave={onSave}
          type={modal.type}
        />
      } 
    </>
  )
}

export default FormWorkedExamples